module.exports = __webpack_public_path__ + "img/4.379762b3.webp";